var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFiremapSymbolLivestock = function SvgFiremapSymbolLivestock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M8.091 9.04 6.46 10.6l.37.464h1.865l1.692 2.293.058 1.367-.303.776h.7l.361-1.98.525 1.17-.07.81h.63l-.198-2.316 1.89-.371.525.961v.788l-.537.938h.63l.98-2.2.746 1.065v.8l-.163.335h.63V9.917h.36v3.452l.392-.388-.169-.168V9.558H10.79l-1.512-.197-.059-.058.148-.147v-.393L9.204 8.6l-.33.329L8.44 8.5H7.205z",
    clipRule: "evenodd"
  })));
};
export default SvgFiremapSymbolLivestock;